import { DSOptionProps } from '@vr/ds-react'

import { API } from '../api'
import { EconomicGroup, EconomicGroupsResponse } from './interface'

export const fetch = async (
  term: string = '',
  page: number = 1,
  pageSize: number = 10,
  startDate?: string,
  endDate?: string
): Promise<{
  items: DSOptionProps[]
  total: number
}> => {
  const params: Record<string, string | number> = {
    termo: term,
    pagina: page,
    tamanhoDaPagina: pageSize,
    ordenacao: 'desc'
  }

  if (startDate) params.dataInicio = startDate
  if (endDate) params.dataFim = endDate

  try {
    const response = await API.get<EconomicGroupsResponse>(
      '/logistica/filtro/Empregador',
      params
    )
    const content = response?.content ?? {}
    const results: EconomicGroup[] = content.itensRespostaBuscarFiltros ?? []
    const total = content.total ?? 0

    const items: DSOptionProps[] = results.map(account => ({
      label: account.nome,
      value: account.id
    }))

    return { items, total }
  } catch (error) {
    console.error('Erro ao buscar grupo econômico:', error)
    return { items: [], total: 0 }
  }
}
